<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        휴가취소 신청
      </v-col>
    </v-row>

    <div class="apply-list px-6 overflow-y-auto">
      <v-text-field
          class="bottom--box"
          label="선택"
          v-model="gntNm"
          readonly
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="근태코드"
          v-model="gntCd"
          readonly
          v-show="false"
        ></v-text-field>
        <span v-show="codeShow">
          <v-text-field
          class="bottom--box"
          append-icon="mdi-chevron-right"
          label="대상자명"
          @click="applLevelSheet1 = !applLevelSheet1"
          v-model="codeNm"
          readonly
        ></v-text-field>
          <v-text-field v-show="false" v-model="code"></v-text-field>
        </span>
      <span v-show="restShow">
      결제 진행 중인 건 포함<br>
      잔여일수: {{ restCnt }}일 / {{ restCntTime }} 시간
      </span>
      <span class="stdOnly hide">
        <span id="stdInfo" class="f_red"></span>
        <v-text-field
          class="bottom--box"
          id="occYmd"
          label="기준일"
          v-model="occYmd"
          readonly
        ></v-text-field>
      </span>
      <v-text-field
        class="bottom--box"
        id="sYmd"
        label="신청 시작일"
        v-model="sYmd"
        readonly
        v-show="sYmdShow"
      ></v-text-field>
      <v-text-field
        class="bottom--box"
        label="신청 종료일"
        id="eYmd"
        v-model="eYmd"
        readonly
        v-show="eYmdShow"
      ></v-text-field>
      <span id="workInfo"></span>
      <span v-show="dayTypeShow">
        <v-text-field
          class="bottom--box"
          label="오전/오후"
          v-model="dayTypeNm"
          readonly
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="dayType"
          label="오전/오후 코드"
          v-model="dayType"
          readonly
          v-show="false"
        ></v-text-field>
        </span>
        <v-text-field
          class="bottom--box"
          id="requestHour"
          label="신청시간"
          v-model="requestHour"
          :readonly="requestHourReadOnly"
        ></v-text-field>
        <span v-show="dayShow">
        <v-text-field
          class="bottom--box"
          id="holDay"
          label="총일수"
          v-model="holDay"
          readonly
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="closeDay"
          label="적용일수"
          v-model="closeDay"
          readonly
        ></v-text-field>
        </span>
        <span v-show="hourSHow">
        <v-text-field
          class="bottom--box"
          id="reqSHm"
          label="시작시간"
          v-model="reqSHm"
          readonly
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="reqEHm"
          label="종료시간"
          v-model="reqEHm"
          readonly
        ></v-text-field>
        </span>
        <v-text-field
          class="bottom--box"
          id="baseCnt"
          label=""
          v-model="baseCnt"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="maxCnt"
          label=""
          v-model="maxCnt"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="srcYy"
          label="사용연차내역 년도"
          v-model="srcYy"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="srcGntCd"
          label="사용연차내역 근태코드"
          v-model="srcGntCd"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="srcUseSYmd"
          label="사용연차내역 사용기준시작일"
          v-model="srcUseSYmd"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="srcUseEYmd"
          label="사용연차휴가 사용기준종료일"
          v-model="srcUseEYmd"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="대리 업무자"
          id="subSabun"
          v-model="subSabunNm"
          readonly

      ></v-text-field>
      <v-text-field
          class="bottom--box"
          label="대리 업무자 사번"
          id="subSabun"
          v-model="subSabun"
          readonly
          v-show="false"
      ></v-text-field>
      <v-text-field v-show="gntReqResonShow"
          class="bottom--box"
          label="신청사유"
          id="gntReqReson"
          v-model="gntReqReson"
          readonly
      ></v-text-field>
      <div class="borderLine-wrap" v-show="fileShow">
        <span class="borderLine-title">첨부파일</span>
        <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          @click="fileFlag = !fileFlag"
        >
        </v-btn>
      </div>
      <bgf-attach-file-add ref="bgfAttachFile" />
      <br/>
      <div>
        <v-text-field
          class="bottom--box"
          label="취소사유"
          id="gntReqReson"
          v-model="cancelGntReqReson"
      ></v-text-field>
      </div>

    </div>

    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applovalPage"
          >
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
   </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg
import { mapGetters } from 'vuex';
import {
  getVacationDetail,
  getVacationAppDetGntCdListDetail,
  getTimeCdMgr,
} from '@/api/workStatus';


import dayjs from 'dayjs';
import routerNames from '@/const/routerConstants';
import BgfAttachFileAdd from '@/components/application/form/BgfAttachFileAdd.vue';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **

export default {
  mixins: [dialogMixin],
  data: () => ({
    gntGubunFlag: false, // 화면플래그
    fileFlag: false,
    dayTypeFlag:  false,
    useTargetAnnualFlag: false,
    selecttitle1: '선택',
    selecttitle2: '오전/오후',
    selecttitle3: '사용휴가',
    gntGubunList: [],
    dayTypeList: [],
    useTargetAnnualList: [],
    gntCd: '',
    gntNm: '',
    sYmd: '',
    eYmd: '',
    occYmd: '',
    restCnt: '',
    restCntTime: '',
    restShow: false,
    holDay: '',
    closeDay: '',
    requestHour: '',
    dayType: 'AM',
    dayTypeNm: '오전',
    reqSHm: '',
    reqEHm: '',
    useTargetAnnualNm: '',
    useTargetAnnual: '',
    sYmdShow: true,
    dayYn: 'Y',
    useTargetAnnualShow: true,
    srcYy: '',
    srcGntCd: '',
    srcUseSYmd: '',
    srcUseEYmd: '',
    baseCnt: '',
    maxCnt: '',
    validRequestHour: 0.125,
    dayShow: true,
    hourSHow: false,
    dayTypeShow: false,
    dayTypeDisabled : false,
    requestHourReadOnly:  true,
    eYmdShow: true,
    sYmdDisabled:  false,
    subSabun: '',
    subSabunNm: '',
    returnValue: true,
    gntReqReson: '',
    cancelGntReqReson: '',
    codeShow: false,
    codeNm: '',
    code: '',
    gntReqResonShow: true,
    fileShow: true,

  }),

  computed: {
    ...mapGetters('ELA', [
      'GET_APPL_SEQ_EXIST',
      'GET_REFER_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',
      'GET_APPL_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_VACCINATION_PARAM',
    ]),
    ...mapGetters([
      'GET_USER_DATA',
      'GET_FAMRSHIPCD_CD',
      'GET_TGT_NAME',
      'GET_FILE_SEQ',
      'GET_PARAMS',
      'GET_VACATION_GNT_GUBUN_MENU',
      'GET_GNT',
      'GET_VACATION_HOLIDAY_CNT',
      'GET_USER_TARGET_ANNUAL',
    ]),
  },

  methods: {

    init() {

      //현재 근태코드의 근태신청유형
      var reqUseType = this.GET_GNT.requestUseType;
      var baseCnt    = this.GET_GNT.baseCnt;

      //최소, 최대 기준일수를 보여줌
      this.baseCnt = baseCnt;
      this.maxCnt = this.GET_GNT.maxCnt;

      //기준일 체크 시
      if (this.GET_GNT.applChkYn === "Y"){
        this.codeShow = true;
        $(".stdOnly").show();
        $(".stdOnly b").text(this.GET_GNT.applStdNm !== ""?this.GET_GNT.applStdNm:"기준일");

        if (this.GET_GNT.useSdateCnt !== "" && this.GET_GNT.useEdateCnt !== "" && this.GET_GNT.useSdateCnt !== null && this.GET_GNT.useEdateCnt != null){
          $("#stdInfo").text("( D-"+this.GET_GNT.useSdateCnt+" ~ D+"+this.GET_GNT.useEdateCnt+" )");
        }
      }else{
        this.codeShow = false;
        $(".stdOnly").hide();
      }

      //근태신청유형에 따라 신청폼을 바꿔주는 화면컨트롤 로직
      //발생휴가 사용인 경우 잔여 표기
      if (this.GET_GNT.vacationYn === "Y"){
        $("#restDayCnt").show();
      }else{
        $("#restDayCnt").hide();
      }

      //휴가형태에 따라
      if( reqUseType == "D" ) {//종일인 경우
        this.dayShow = true;
        this.hourSHow = false;
        this.eYmdShow = true;
        this.dayYn = "Y";
        this.dayTypeShow = false;

      } else {

        this.dayShow = false;
        this.hourSHow = true;
        this.eYmdShow = false;
        this.dayYn = "N";

        if (this.GET_GNT.baseCnt === this.GET_GNT.maxCnt){	//시간 고정인 경우
          this.requestHourReadOnly = true;
        }else{
          this.requestHourReadOnly = false;
        }

        if(reqUseType != "H"){
          this.dayTypeShow = false;
          this.dayTypeDisabled = true;
          this.dayType = reqUseType;
        }else{
          this.dayTypeShow = true;
          this.dayTypeDisabled = false;
          this.dayType = 'AM';
        }
    }
	},

    async applovalPage() {
       /*
      if (this.gntCd.trim() === '') {
        alert('근태는 필수값입니다');
        return;
      }

      if (this.sYmd.trim() === '') {
        alert('신청시작일은 필수값입니다');
        return;
      }

      if (this.eYmd.trim() === '') {
        alert('신청종료일은 필수값입니다.');
        return;
      }

      if(this.dayTypeShow) {
        if(this.dayTypeNm.trim() === '') {
          alert('오전/오후는 필수값입니다.');
          return;
        }
      }

      if (this.GET_GNT.applChkYn  === "Y"){
        if( this.occYmd === null || this.occYmd.trim() === ""){
          alert("기준일은 필수값입니다.");
          return false;
        }
      }


      if( this.GET_GNT.requestUseType != "D"){
        if( this.reqSHm === null || this.reqSHm.trim() === ""){
          alert("시작시간은 필수값입니다.");
          return false;
        }
        if( this.reqEHm === null || this.reqEHm.trim()  === ""){
          alert("종료시간은 필수값입니다.");
          return false;
        }
      }
      */

    /*
    if( this.useTargetAnnualNm === '') {
          alert("사용 연차휴가를 선택해 주시기 바랍니다.");
          return false;
    }

    await this.logicValidation();

    if(!this.returnValue) {
      return;
    }

    if (this.subSabunNm.trim() === '') {
      alert('근태신청시 대리업무자 지정해주시기 바랍니다.');
      return;
    }

    const param = {
      sYmd : this.sYmd.replaceAll('-', ''),
      eYmd : this.eYmd.replaceAll('-', ''),
    }

    let res = await getApplYnChk(param);

    if (res.data.data.chk === 'Y') {
      alert("해당 기간에 신청 중인 근태가 있습니다.");
      return;
    }
    */

    if (this.cancelGntReqReson.trim() === '') {
      alert('취소사유는 필수값입니다');
      return;
    }

    const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: '23',
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        searchApplName: this.GET_USER_DATA.ssnName,
        authPg: 'A', // A신청, R결제
        pathSeq: '',
        applStatusCd: '31', //수신처리중
        fileSeq: this.GET_FILE_SEQ,
        procExecYn: this.GET_UI_INFO.procExecYn,
        etc01: this.GET_UI_INFO.etc01,
        etc02: this.GET_UI_INFO.etc02,
        etc03: this.GET_UI_INFO.etc03,
        etc04: this.GET_UI_INFO.etc04,
        etc05: this.GET_UI_INFO.etc05,
        tgtName: this.GET_USER_DATA.ssnName,
        applTypeCd: '10', //본인신청
        gntNm : this.gntNm,
        gntCd : this.gntCd,

        restCnt : this.restCnt,
        restCntTime : this.restCntTime,

        occYmd : this.occYmd,
        sYmd : this.sYmd,
        eYmd : this.eYmd,

        dayTypeNm : this.dayTypeNm,
        dayType : this.dayType,

        holDay : this.holDay,
        closeDay : this.closeDay,

        reqSHm : this.reqSHm,
        reqEHm : this.reqEHm,
        requestHour : this.requestHour,

        useTargetAnnual : this.useTargetAnnual,
        useTargetAnnualNm : this.useTargetAnnualNm,

        baseCnt : this.baseCnt,
        maxCnt : this.maxCnt,

        srcYy : this.srcYy,
        srcGntCd : this.srcGntCd,
        srcUseSYmd : this.srcUseSYmd,
        srcUseEYmd : this.srcUseEYmd,

        subSabunNm : this.subSabunNm,
        subSabun : this.subSabun,
        gntReqReson: this.cancelGntReqReson,
        gntGubunCd: this.GET_VACATION_GNT_GUBUN_MENU.code,
        params: this.$route.params.applSeq===undefined?this.GET_PARAMS.params:this.$route.params,
        cancelGntReqReson: this.cancelGntReqReson,
        isCancelVacation: true,
        searchBApplSeq: this.$route.params.applSeq===undefined?this.GET_PARAMS.params.applSeq:this.$route.params.applSeq,
      };

      this.GET_ELA_APPL_PARAM.searchApplCd = '23';

      this.$store.commit('SET_AUTHPG', 'A');
      this.$store.commit('SET_PARAMS', params);
      this.$store.dispatch('ELA/SET_VACATION_PARAMS', params);
      this.$store.commit('SET_APPL_CD', '23');
      this.$router.push({name:routerNames.ApprovalLine, params:{applSeqExist:'N'}});
    },

  },

  async mounted() {

    let response;

    if(this.$route.params.applSeq === undefined) {
      response = await getVacationDetail(this.GET_PARAMS.params);
    } else {
      response = await getVacationDetail(this.$route.params);
    }

    console.dir(response);

    const param = {
      gntCd : response.data.data.gntCd,
    }

    this.gntCd = response.data.data.gntCd;
    this.occYmd = response.data.data.occYmd;
    this.sYmd = response.data.data.sYmd;
    this.eYmd = response.data.data.eYmd;
    this.holDay = response.data.data.holDay;
    this.closeDay = response.data.data.closeDay;
    this.reqSHm = response.data.data.reqSHm!==null?response.data.data.reqSHm.substring(0, 2)+':'+response.data.data.reqSHm.substring(2, 4):'';
    this.reqEHm = response.data.data.reqEHm!==null?response.data.data.reqEHm.substring(0, 2)+':'+response.data.data.reqEHm.substring(2, 4):'';
    this.requestHour = response.data.data.requestHour;
    this.subSabunNm = response.data.data.subSabunNm;
    this.gntReqReson = response.data.data.gntReqReson;
    this.dayTypeNm = response.data.data.dayType==='AM'?'오전':'오후';
    this.codeNm = response.data.data.targetInfo;

    this.cancelGntReqReson = this.GET_PARAMS.cancelGntReqReson===undefined?'':this.GET_PARAMS.cancelGntReqReson;

    response = await getVacationAppDetGntCdListDetail(param);
    this.$store.commit('SET_GNT', response.data.data);
    this.gntNm = response.data.data.codeNm;
    this.init();
    this.OFF_APP_SPINNER();

    param.searchGntCd = param.gntCd;
    response = await getTimeCdMgr(param);

    // console.log('response :: '+JSON.stringify(response));
    //alert(JSON.stringify(this.GET_UI_INFO));

    if (response.data.data.autoAgreeYn === 'Y') {
      this.$store.commit('ELA/SET_ORG_LVL', this.GET_UI_INFO.orgLevelCd);
    } else {
      this.$store.commit('ELA/SET_ORG_LVL', this.GET_UI_INFO.orgLevelCd);
    }

    if (response.data.data.noteYn === 'N') {
      this.gntReqResonShow = false;
    }

    if (this.GET_UI_INFO.fileYn === 'N') {
      this.fileShow = false;
    } else {
      if (response.data.data.fileYn === 'N') {
        this.fileShow = false;
      }
    }
  },

  components: {
    IconApprovalDoc,
    BgfAttachFileAdd,

  },
};
</script>

<style>
/* _approval.scss 에 넣음 */
/* dialog */
/* .v-dialog:not(.v-bottom-sheet) {
  background-color: white;
  height: inherit;
} */
</style>
